import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  useEffect(() => {
    document.title = 'HexaCRM - Services';
  }, []);

  const services = [
    {
      id: 1,
      title: 'CRM Solutions',
      description: 'Comprehensive customer relationship management tools to help you track, manage, and nurture your customer relationships effectively.',
      iconClass: 'icon-shape-primary',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
          <path fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
          <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
        </svg>
      )
    },
    {
      id: 2,
      title: 'Data Analytics',
      description: 'Powerful analytics and reporting tools that transform your data into actionable insights for better business decisions.',
      iconClass: 'icon-shape-success',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"/>
        </svg>
      )
    },
    {
      id: 3,
      title: 'Marketing Automation',
      description: 'Automate your marketing campaigns with smart tools that help you reach the right audience at the right time.',
      iconClass: 'icon-shape-warning',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/>
          <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0v5zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3z"/>
        </svg>
      )
    },
    // {
    //   id: 4,
    //   title: 'Sales Management',
    //   description: 'Streamline your sales pipeline with intuitive tools for tracking leads, opportunities, and closing deals faster.',
    //   iconClass: 'icon-shape-info',
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    //       <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9A1.5 1.5 0 0 1 1.5 3H2V1.78a1.5 1.5 0 0 1 1.864-1.454l8.272 2zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/>
    //     </svg>
    //   )
    // },
    // {
    //   id: 5,
    //   title: 'Customer Support',
    //   description: 'Deliver exceptional customer support with ticketing systems, live chat, and self-service knowledge bases.',
    //   iconClass: 'icon-shape-secondary',
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    //       <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>
    //     </svg>
    //   )
    // },
    // {
    //   id: 6,
    //   title: 'Cloud Integration',
    //   description: 'Seamlessly integrate with your favorite cloud services and third-party applications for a unified workflow.',
    //   iconClass: 'icon-shape-primary',
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    //       <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
    //     </svg>
    //   )
    // },
    {
      id: 7,
      title: 'Twilio Integration',
      description: 'Enable SMS, and voice communications with Twilio integration for seamless customer engagement and notifications.',
      iconClass: 'icon-shape-secondary',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
        </svg>
      )
    },
    {
      id: 8,
      title: 'Asterisk PBX',
      description: 'Enterprise-grade telephony solutions with Asterisk PBX integration for call routing, IVR, call recording, and advanced voice features.',
      iconClass: 'icon-shape-success',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"/>
        </svg>
      )
    },
    {
      id: 9,
      title: 'WhatsApp Business',
      description: 'Connect with customers on WhatsApp for instant messaging, broadcast notifications, and seamless sharing of documents and media.',
      iconClass: 'icon-shape-info',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
        </svg>
      )
    }
  ];

  return (
    <div>
      {/* Page Header */}
      <section className="page-header">
        <div className="container position-relative z-2">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-3 text-white fw-bold">Our Services</h1>
              <p className="lead hero-text">
                Comprehensive solutions designed to transform your business operations
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-lg">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 mb-4">
                <div className="card card-lift h-100">
                  <div className="card-body p-4">
                    <div className={`icon icon-shape ${service.iconClass} icon-lg mb-4`}>
                      {service.icon}
                    </div>
                    <h5 className="fw-bold">{service.title}</h5>
                    <p className="text-muted mb-4">
                      {service.description}
                    </p>
                    {/* <a href="#" className="text-primary fw-bold text-decoration-none">
                      Learn More &rarr;
                    </a> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      {/* <section className="py-lg bg-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <span className="badge badge-primary mb-3">Why Us</span>
              <h2 className="display-5 fw-bold mb-4">Built for Modern Businesses</h2>
              <p className="lead text-muted mb-4">
                Our platform is designed with the modern business in mind, offering
                flexibility, scalability, and ease of use.
              </p>
              <ul className="list-unstyled">
                <li className="d-flex align-items-start mb-3">
                  <div className="icon icon-shape icon-shape-primary icon-sm me-3 flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                    </svg>
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Easy to Use</h6>
                    <p className="text-muted mb-0 small">Intuitive interface that requires minimal training</p>
                  </div>
                </li>
                <li className="d-flex align-items-start mb-3">
                  <div className="icon icon-shape icon-shape-success icon-sm me-3 flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                    </svg>
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Scalable</h6>
                    <p className="text-muted mb-0 small">Grows with your business from startup to enterprise</p>
                  </div>
                </li>
                <li className="d-flex align-items-start mb-3">
                  <div className="icon icon-shape icon-shape-warning icon-sm me-3 flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                    </svg>
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Secure</h6>
                    <p className="text-muted mb-0 small">Enterprise-grade security with data encryption</p>
                  </div>
                </li>
                <li className="d-flex align-items-start">
                  <div className="icon icon-shape icon-shape-info icon-sm me-3 flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                    </svg>
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">24/7 Support</h6>
                    <p className="text-muted mb-0 small">Round-the-clock customer support when you need it</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="card shadow-lg">
                <div className="card-body p-5">
                  <h4 className="fw-bold mb-4">Get a Free Demo</h4>
                  <form>
                    <div className="mb-3">
                      <input type="text" className="form-control form-control-lg" placeholder="Your Name" />
                    </div>
                    <div className="mb-3">
                      <input type="email" className="form-control form-control-lg" placeholder="Email Address" />
                    </div>
                    <div className="mb-3">
                      <input type="text" className="form-control form-control-lg" placeholder="Company Name" />
                    </div>
                    <div className="mb-4">
                      <select className="form-select form-select-lg">
                        <option>Select Service</option>
                        <option>CRM Solutions</option>
                        <option>Data Analytics</option>
                        <option>Marketing Automation</option>
                        <option>Sales Management</option>
                        <option>Customer Support</option>
                        <option>Cloud Integration</option>
                      </select>
                    </div>
                    <button type="submit" className="btn btn-primary btn-lg w-100">
                      Request Demo
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-lg bg-gradient-primary">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="display-5 text-white fw-bold mb-4">
                Ready to Get Started?
              </h2>
              <p className="lead hero-text mb-5">
                Contact us today to learn how our services can help transform your business
                and build stronger customer relationships.
              </p>
              {/* <div className="d-flex justify-content-center gap-3">
                <Link to="/about" className="btn btn-white btn-lg">
                  Learn More
                </Link>
                <a href="#" className="btn btn-outline-light btn-lg">
                  Contact Sales
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
